var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableOfContents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#table-of-contents_svg__clip0_61530_7340)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5H3V6h13.5V4.5zM16.5 9H3v1.5h13.5V9zM16.5 13.5H3V15h13.5v-1.5zM16.5 18H3v1.5h13.5V18zM21 4.5h-1.5V6H21V4.5zM21 9h-1.5v1.5H21V9zM21 13.5h-1.5V15H21v-1.5zM21 18h-1.5v1.5H21V18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "table-of-contents_svg__clip0_61530_7340"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTableOfContents;